import React from "react";
import classNames from "classnames";
import { IconProps, IconDimensions } from "../../types";
import { getIconDimensions } from "../../../utils/icon-utils";

export const IconWarningTriangleFull = ({
  title,
  titleId,
  color,
  className: classNameProp,
  size,
  height,
  width,
  ...restProps
}: IconProps) => {
  const className = classNames(
    {
      [`text-${color}`]: color !== undefined,
    },
    classNameProp
  );

  const defaultDimensions: IconDimensions = {
    height: 24,
    width: 24,
  };
  const props = {
    className,
    ...getIconDimensions(size, width, height, defaultDimensions?.width, defaultDimensions?.height),
    ...restProps,
  };

  return (
    <svg viewBox="0 0 24 24" fill="currentcolor" {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.438 3.467a3.01 3.01 0 012.572-1.454c1.049 0 2.021.547 2.571 1.454L22.865 17.5A3 3 0 0120.29 22H3.721a3 3 0 01-2.56-4.508L9.437 3.467ZM11 8.65a.65.65 0 01.65-.65h.7c.359 0 .65.291.65.65v4.7a.65.65 0 01-.65.65h-.7a.65.65 0 01-.65-.65v-4.7Zm.65 7.35a.65.65 0 00-.65.65v.7c0 .359.291.65.65.65h.7a.65.65 0 00.65-.65v-.7a.65.65 0 00-.65-.65h-.7Z"
        fill="currentcolor"
      />
    </svg>
  );
};

IconWarningTriangleFull.displayName = "IconWarningTriangleFull";
